/**
 * APP: Taako.
 *
 * Vignette container
 * Experimental. Generate a secondary canvas context
 * to draw a gradient then copy that as a texture.
 *
 */

import React from 'react';
import { Sprite } from '@inlet/react-pixi';
import * as PIXI from 'pixi.js'

export class VignetteContainer extends React.Component {

  constructor(props) {
    super(props);
    this.texture = undefined;

    this.state = {
      sw: 0,
      sh: 0,
      ready: false,
      alpha: 0.75
    };
  }

  componentDidMount() {
    this.setState({
      ready: true
    })
    this.texture = this.generateVignetteGradient();
    this.updateVigAlpha();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.sw !== window.innerWidth ||
      prevState.sh !== this.props.screen.sh
    ) {
      this.texture = this.generateVignetteGradient();
      this.updateVigAlpha();
    }
  }

  updateVigAlpha = () => {
    let stageWidth = window.innerWidth;
    let maxAlpha = 0.75;
    let alpha = stageWidth*0.00075;
    this.setState({
      alpha: ( alpha > maxAlpha ) ? maxAlpha : alpha
    })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if ( prevState.sw !== nextProps.screen.sw ||
         prevState.sh !== nextProps.screen.sh ) {
      return {
        sw: nextProps.screen.sw,
        sh: nextProps.screen.sh
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if ( this.state !== nextState ) {
      return true
    } else {
      return false
    }
  }

  generateVignetteGradient = () => {

    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
        canvas.width = this.state.sw;
        canvas.height = this.state.sh;
    let grd = ctx.createRadialGradient(
                    this.state.sw * 0.5,   // c1x
                    this.state.sh * 0.5,   // c1y
                    0,                     // c1 rad
                    this.state.sw * 0.5,   // c2x
                    this.state.sh * 0.5,   // c2y
                    this.state.sw * 0.6 ); // c2 rad
        grd.addColorStop(0,"rgba(0,0,0,0)");
        grd.addColorStop(0.25,"rgba(0,0,0,0)");
        grd.addColorStop(1,"black");
        ctx.fillStyle = grd;
        ctx.fillRect(0, 0, this.state.sw, this.state.sh);

        return PIXI.Texture.fromCanvas( canvas );
  }

  render() {
    return (
        this.state.ready &&
            <Sprite
              texture={ this.texture }
              alpha={ this.state.alpha }
              x={0}
              y={0}
              anchor={[0,0]} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layers/Vignette.js